import { graphql } from 'react-apollo';

import { CurrentClaim } from '../../queries/CurrentClaim';
import { paginationVariables } from '../../utils/pagination';

const ITEMS_PER_PAGE = 30;

const withClaimQuery = graphql(CurrentClaim, {
  options: props => ({
    variables: {
      id: props.claimId || props.match.params.id,
      ...paginationVariables(props, ITEMS_PER_PAGE)
    }
  }),
  props: ({ data: { claim, variables, loading, error,refetch } }) => ({
    error,
    loading,
    variables,
    claim,
    refetch
  })
});

export default withClaimQuery;



// WEBPACK FOOTER //
// ./src/component/HOC/withClaimQuery.js